import React from "react";

import ContainerAuthenticated from "containers/Authenticated";
import useController from "./controller";
import { ContainerImages, ImageCard, ImageCardContent, ImageCardContentText, ImageCardImage, QualifierLayout, QualifierColumn, SectionTitle, StatusBadge, AiSuggestionText } from "./styled";
import { parseStrapiImage } from "utils";
import Button from "components/Form/Button";
import { Icon } from "ui/styled";

export default function ImageQualifier() {

    const {
        loading,
        registers,
        handleUploadAll
    } = useController()

    const imageRegisters = (registers || []).filter((f) =>
        f?.name?.endsWith(".png")
        || f?.name?.endsWith(".PNG")
        || f?.name?.endsWith(".jpg")
        || f?.name?.endsWith(".JPG")
        || f?.name?.endsWith(".jpeg")
        || f?.name?.endsWith(".JPEG")
    )

    const getAiStatus = (caption) => {
        const text = String(caption || "").toLowerCase();
        if (text.includes("ai-qualifier:success")) return "success";
        if (text.includes("ai-qualifier:failed")) return "failed";
        return null;
    };

    const enrichedImages = imageRegisters
        .map((m) => {
            const aiStatus = getAiStatus(m?.caption);
            const aiSuggestion = aiStatus === "success" ? String(m?.suggestion || m?.name || "").trim() : "";
            const displayStatus = aiStatus === "success" && aiSuggestion ? "success" : "failed";
            return { ...m, aiStatus: displayStatus, aiSuggestion };
        });

    const pendingImages = enrichedImages.filter((m) => !getAiStatus(m?.caption));
    const successImages = enrichedImages.filter((m) => m?.aiStatus === "success");
    const failedImages = enrichedImages.filter((m) => !!getAiStatus(m?.caption) && m?.aiStatus === "failed");

    return (

        <QualifierLayout>
            <QualifierColumn>
                <SectionTitle>Pending images ({pendingImages.length})</SectionTitle>
                <Button color="primary" loading={loading === "all"} onClick={() => handleUploadAll(pendingImages)}>
                    Generate all titles with AI <Icon width={20} icon={"ai-engine"} />
                </Button>
                <ContainerImages>
                    {pendingImages?.map((m, k) => (
                        <ImageCard key={`pending-${m?.id || k}`}>
                            <ImageCardImage image={m?.url ? parseStrapiImage(m?.url) : null} />
                            <ImageCardContent>
                                <ImageCardContentText>Original name: {m?.name}</ImageCardContentText>
                            </ImageCardContent>
                        </ImageCard>
                    ))}
                </ContainerImages>
            </QualifierColumn>

            <QualifierColumn>
                <SectionTitle>Successful images ({successImages.length})</SectionTitle>
                <ContainerImages>
                    {successImages?.map((m, k) => (
                        <ImageCard key={`processed-${m?.id || k}`}>
                            <ImageCardImage image={m?.url ? parseStrapiImage(m?.url) : null} />
                            <ImageCardContent>
                                <ImageCardContentText>Original name: {m?.name}</ImageCardContentText>
                                {m?.aiSuggestion ? <AiSuggestionText>AI suggestion: {m?.aiSuggestion}</AiSuggestionText> : null}
                                <StatusBadge status={m?.aiStatus}>{m?.aiStatus}</StatusBadge>
                            </ImageCardContent>
                        </ImageCard>
                    ))}
                </ContainerImages>
            </QualifierColumn>

            <QualifierColumn>
                <SectionTitle>Failed images ({failedImages.length})</SectionTitle>
                <ContainerImages>
                    {failedImages?.map((m, k) => (
                        <ImageCard key={`failed-${m?.id || k}`}>
                            <ImageCardImage image={m?.url ? parseStrapiImage(m?.url) : null} />
                            <ImageCardContent>
                                <ImageCardContentText>Original name: {m?.name}</ImageCardContentText>
                                <StatusBadge status="failed">failed</StatusBadge>
                            </ImageCardContent>
                        </ImageCard>
                    ))}
                </ContainerImages>
            </QualifierColumn>
        </QualifierLayout>

    );
}
